import {useDebugValue} from 'react';

import {undef, DEFAULT_SUBMIT_ACTION_TYPE} from '../../../utils';

import {useOptions} from './';

const defaultSubmitOptions = {
    actionType: DEFAULT_SUBMIT_ACTION_TYPE,
    iconName: 'search',
    isPrimaryAction: true,
    showIcon: undef
};

function useSubmitOptions(props) {
    const {
        submitOptions: propsSubmitOptions
    } = props;

    const {
        options: submitOptions
    } = useOptions(defaultSubmitOptions, propsSubmitOptions);

    const result = {
        submitOptions
    };

    useDebugValue(result);

    return result;
}

export {useSubmitOptions};
